import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './article-group.scss.js';

class ArticleGroup extends s {
    render() {
        return x `<slot></slot>`;
    }
}
ArticleGroup.styles = css_248z;
customElements.define('article-group', ArticleGroup);

export { ArticleGroup };
